import { render } from "./WebLayout.vue?vue&type=template&id=5fb1cf2d"
import script from "./WebLayout.vue?vue&type=script&lang=js"
export * from "./WebLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__